export const RESET_DOCS_USER = 'RESET_DOCS_USER';
export const REMOVE_DOCUMENT_FROM_LISTS = 'REMOVE_DOCUMENT_FROM_LISTS';
export const SAVE_DOCS_USER_TO_EDIT = 'SAVE_DOCS_USER_TO_EDIT';
export const SAVE_DOCS_USER_TO_SIGN = 'SAVE_DOCS_USER_TO_SIGN';
export const SAVE_DOCS_USER_PUBLISHED = 'SAVE_DOCS_USER_PUBLISHED';
export const STAR_DOCS = 'STAR_DOCS';
export const STAR_DOC_TO_EDIT = 'STAR_DOC_TO_EDIT';
export const STAR_DOC_TO_SIGN = 'STAR_DOC_TO_SIGN';
export const STAR_DOC_PUBLISHED = 'STAR_DOC_PUBLISHED';
